module.exports = __webpack_public_path__ + "static/media/9U.2787e043.png";